import qs from 'qs';

export const parsePaging = (search) => {
    const { page = '0', perPage = '15' } = qs.parse(search, { ignoreQueryPrefix: true });
    return {
        page: parseInt(page, 10),
        perPage: parseInt(perPage, 10),
    };
};

export const parseSorting = (search) => {
    const { sortKey, sortDirection } = qs.parse(search, { ignoreQueryPrefix: true });
    return { sortKey, sortDirection };
};

export const parseQuery = (search) => {
    const { query } = qs.parse(search, { ignoreQueryPrefix: true });
    return query;
};

export const parseIncludeDeactivated = (search) => parseBooleanProperty(search, 'includeDeactivated');
export const parseIncludeDeleted = (search) => parseBooleanProperty(search, 'includeDeleted');

export const parseBooleanProperty = (search, propertyName) => {
    const propertyValue = qs.parse(search, { ignoreQueryPrefix: true })[propertyName];
    return (propertyValue && propertyValue.toLowerCase() === 'true') || false;
};

export const parseFilter = (search) => parseProperty(search, 'filter', 'ALL');

export const parseProperty = (search, propertyName, defaultValue = null) => {
    const propertyValue = qs.parse(search, { ignoreQueryPrefix: true })[propertyName];
    return propertyValue || defaultValue;
};

export const parseResetToken = (search) => {
    const { resetToken } = qs.parse(search, { ignoreQueryPrefix: true });
    return resetToken;
};

export const parseReset2faToken = (search) => {
    const { reset2faToken } = qs.parse(search, { ignoreQueryPrefix: true });
    return reset2faToken;
};

export const parseSsoCode = (search) => {
    const { code } = qs.parse(search, { ignoreQueryPrefix: true });
    return code;
};
